export default __webpack_public_path__ + "static/img5-ac5174989a695b153ae781820facd729.png";